var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataType } from '@easydata/core';
import { ChartWidget } from './chart_widget';
import { ChartType } from './chart_type';
var GoogleChartWidget = /** @class */ (function (_super) {
    __extends(GoogleChartWidget, _super);
    /**
     * The default constructor.
     * @param slot The html element.
     * @param provider The provider.
     */
    function GoogleChartWidget(slot) {
        var _this = _super.call(this, slot) || this;
        _this.hasChartTypes = [
            ChartType.Column,
            ChartType.Bar,
            ChartType.Histogram,
            ChartType.Combo,
            ChartType.Area,
            ChartType.Line,
            ChartType.SteppedLine,
            ChartType.Pie,
            ChartType.Doughnut
        ];
        _this.options.legend = {
            show: true,
            position: 'right'
        };
        return _this;
    }
    GoogleChartWidget.prototype.getWidgetType = function () {
        return 'chartGoogle';
    };
    GoogleChartWidget.prototype.canDraw = function () {
        return GoogleChartWidget.hasGoogleCharts();
    };
    GoogleChartWidget.hasGoogleCharts = function () {
        return typeof google !== 'undefined' && typeof google.charts !== 'undefined';
    };
    GoogleChartWidget.prototype.initChart = function () {
        if (GoogleChartWidget.hasGoogleCharts() && this.labelColumn >= 0
            && this.dataColumns && this.dataColumns.length > 0) {
            this.googleDataView =
                new google.visualization.DataView(this.convertToGoogleFormat());
            this.updateChartColumns();
        }
    };
    GoogleChartWidget.prototype.convertToGoogleType = function (type) {
        switch (type) {
            case DataType.Date:
                return "date";
            case DataType.DateTime:
                return "datetime";
            case DataType.Time:
                return "timeofday";
            case DataType.Byte:
            case DataType.Word:
            case DataType.Int32:
            case DataType.Int64:
            case DataType.Currency:
            case DataType.Float:
                return "number";
            default:
                return "string";
        }
    };
    GoogleChartWidget.prototype.convertToGoogleValue = function (value, type) {
        switch (type) {
            case DataType.Bool:
                return value ? value.toString() : null;
            default:
                return value;
        }
    };
    GoogleChartWidget.prototype.convertToGoogleFormat = function () {
        var googleTable = new google.visualization.DataTable();
        var columns = this.dataTable.columns;
        for (var i = 0; i < columns.count; i++) {
            var column = columns.get(i);
            googleTable.addColumn(this.convertToGoogleType(column.type), column.label, column.id);
        }
        var rows = this.dataTable.getCachedRows();
        googleTable.addRows(rows.length);
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            for (var j = 0; j < columns.count; j++) {
                googleTable.setCell(i, j, this.convertToGoogleValue(row.getValue(j), columns.get(j).type));
            }
        }
        return googleTable;
    };
    GoogleChartWidget.prototype.drawCore = function () {
        if (this.googleDataView != null) {
            this.options.legend = this.options.legend || {};
            var chartOptions = {
                width: "100%",
                height: "100%",
                chartArea: { width: this.getChartAreaWidth }
            };
            if (this.chartType == ChartType.Doughnut) {
                chartOptions.pieHole = 0.4;
            }
            if (!this.options.legend.show) {
                chartOptions.legend = 'none';
            }
            else {
                chartOptions.legend = { position: this.options.legend.position };
            }
            var chart = this.createChart(this.chartDiv);
            chart.draw(this.googleDataView, chartOptions);
        }
    };
    GoogleChartWidget.prototype.getChartAreaWidth = function (chartType) {
        if (chartType == ChartType.Pie) {
            return "100%";
        }
        else {
            return "50%";
        }
    };
    GoogleChartWidget.prototype.updateChartColumns = function () {
        if (this.googleDataView) {
            this.googleDataView.setColumns([].concat(this.labelColumn).concat(this.dataColumns));
        }
    };
    GoogleChartWidget.prototype.createChart = function (slot) {
        switch (this.chartType) {
            case ChartType.Column:
                return new google.visualization.ColumnChart(slot);
            case ChartType.Histogram:
                return new google.visualization.Histogram(slot);
            case ChartType.Bar:
                return new google.visualization.BarChart(slot);
            case ChartType.Combo:
                return new google.visualization.ComboChart(slot);
            case ChartType.Area:
                return new google.visualization.AreaChart(slot);
            case ChartType.Line:
                return new google.visualization.LineChart(slot);
            case ChartType.SteppedLine:
                return new google.visualization.SteppedAreaChart(slot);
            case ChartType.Pie:
            case ChartType.Doughnut:
                return new google.visualization.PieChart(slot);
            default:
                return new google.visualization.PieChart(slot);
        }
    };
    return GoogleChartWidget;
}(ChartWidget));
export { GoogleChartWidget };
//# sourceMappingURL=chart_widget_google.js.map